import script from "./user-preferences.vue?vue&type=script&setup=true&lang=js"
export * from "./user-preferences.vue?vue&type=script&setup=true&lang=js"

import "./user-preferences.vue?vue&type=style&index=0&id=1f24e226&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f24e226"]])

export default __exports__